<template>
  <profile-field-select
    :profile="profile"
    attribute="submittedToVa"
    name="VA certification"
    :options="submittedToVaOptions"
    :resolve-variant="resolveSubmittedToVaVariant"
    @updated="$emit('updated', $event)"
  />
</template>

<script>
import ProfileFieldSelect from './ProfileFieldSelect.vue';
import { submittedToVaOptions, resolveSubmittedToVaVariant } from '../vaSubmission';

/**
 * VA certification status, editable in place from any list that shows it
 * (DEV-735).
 */
export default {
  name: 'ProfileSubmittedToVaSelect',
  components: { ProfileFieldSelect },
  props: {
    /** The roster profile (must carry `id` and `attributes`). */
    profile: { type: Object, default: null },
  },
  emits: ['updated'],
  data() {
    return { submittedToVaOptions };
  },
  methods: {
    resolveSubmittedToVaVariant,
  },
};
</script>
